export default {
  managerFeedback: 'Menedżer',
  placeholder: 'Dodaj komentarz...',
  noAttachments: 'Nic',
};
